// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"breadcrumbs_breadcrumbs__zyZ-Y"};